import React from 'react'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import "../../assets/css/JobDetailStart.css"
import { client, note, singleProfile } from '../../Constant'

function JobDetailStart() {
  return (
    <>
    <Header/>
        <section className="job_detail">
    <div className="container-fluid">
        <div className="row">
            <div className="col-md-9">
                <div className="full_booking_detail">
                    <div className="row">
                        <div className="col-md-9">
                            <div className="heading_wrapper heading_wrapper pb-2">
                                <div className="booking_id">
                                    <p>Booking Id (CC10297)</p>
                                </div>
                                <div className="name">
                                    <h4>Baby Sitter Required for 2 Days.</h4>
                                </div>
                            </div>
                            <div className="about_profile">
                                <div className="care_giver">
                                    <div className="img_box">
                                        <figure><img src={singleProfile} alt="" /></figure>
                                        <div className="name">
                                            <h6 className="care_giver_name">Jane Wills</h6>
                                            <span className="type">Child Care</span>
                                        </div>
                                    </div>
                                    <div className="rating">
                                        <p><i className="fa fa-star" aria-hidden="true"></i> 4.5</p>
                                    </div>
                                </div>
                                <ul className="all_details">
                                    <li><i className="fa fa-usd" aria-hidden="true"></i> <span>$100 </span>(2 Hours)</li>
                                    <li><i className="fa fa-calendar-o" aria-hidden="true"></i> 28 August 2021</li>
                                    <li><i className="fa fa-clock-o" aria-hidden="true"></i> 05 : 30 PM</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="button-group">
                                <button className="btn end_all_jobs"> End
                                    All
                                    Jobs</button>
                            </div>
                            <div className="status">
                                <p><img src={note} alt="" /> In Progress</p>
                            </div>
                        </div>
                    </div>
                    <div className="bottom_bar">
                        <div className="addressDv">
                            <p><i className="fa fa-map-marker" aria-hidden="true"></i> 10515 Fox Ave Fairdale,
                                Kentucky(KY), 40118 TX | USA <a href="#">View on Map</a></p>
                        </div>
                        <div className="remaining_time">
                            <p>Time Remaining <span className="time">1 Days | 05 Hours | 57 Mins</span></p>
                        </div>
                    </div>
                </div>
                <div className="description_box">
                    <h4>Description</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                        labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur
                        adipiscing elit <a href="#">Read More</a></p>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="visit_box">
                            <div className="date">
                                <h5>Thurs, 17 August </h5>
                            </div>
                            <div className="visitingDv">
                                <div className="form-group">
                                    <h5>First Visit</h5>
                                    <div className="inputs_group">
                                        <div className="inputs">
                                            <div className="form-group">
                                                <label>Start Time</label>
                                                <input type="time" readonly value="17:30" className="form-control" />
                                            </div>
                                            <span>-</span>
                                            <div className="form-group">
                                                <label>End Time</label>
                                                <input type="time" readonly value="19:30" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="button btn end_job">End job</div>
                                    </div>
                                </div>
                            </div>
                            <div className="visitingDv">
                                <div className="form-group">
                                    <h5>First V isit</h5>
                                    <div className="inputs_group">
                                        <div className="inputs">
                                            <div className="form-group">
                                                <label>Start Time</label>
                                                <input type="time" readonly value="15:30" className="form-control" />
                                            </div>
                                            <span>-</span>
                                            <div className="form-group">
                                                <label>End Time</label>
                                                <input type="time" readonly value="18:30" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="button btn waiting_job">Waiting For Prev Job</div>
                                    </div>
                                </div>
                            </div>
                            <div className="date mt-5">
                                <h5>Friday, 18 August </h5>
                            </div>
                            <div className="visitingDv">
                                <div className="form-group">
                                    <h5>First V isit</h5>
                                    <div className="inputs_group">
                                        <div className="inputs">
                                            <div className="form-group">
                                                <label>Start Time</label>
                                                <input type="time" readonly value="15:30" className="form-control" />
                                            </div>
                                            <span>-</span>
                                            <div className="form-group">
                                                <label>End Time</label>
                                                <input type="time" readonly value="18:30" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="button btn waiting_job">Waiting For Prev Job</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="client_details">
                            <div className="heading">
                                <h4>Client Details</h4>
                            </div>
                            <ul className="details">
                                <li>
                                    <h5 className="property">Full Name of Client</h5>
                                    <h5 className="value">James Anderson</h5>
                                </li>
                                <li>
                                    <h5 className="property">Gender</h5>
                                    <h5 className="value">Male</h5>
                                </li>
                            </ul>
                            <div className="detail_about_person mt-4">
                                <h5>Details About the Person who is directly getting service</h5>
                                <p>
                                    James is 15 Years old Kid. sit amet, consectetur adipiscing elit, sed do eiusmod
                                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem
                                    ipsum dolor sit amet, consectetur adipiscing elit
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-3">
                <div className="client-box">
                    <div className="img_box">
                        <figure><img src={client} alt="" /></figure>
                    </div>
                    <div className="about_client">
                        <h5 className="name">Jane Wills</h5>
                        <span className="type">Client</span>
                        <p className="member_since">Member Since - Jan 2018</p>
                    </div>
                    <div className="address">
                        <p className="location"><i className="fa fa-map-marker" aria-hidden="true"></i> Manchester, England</p>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidid
                            consectetur
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<Footer />
    </>
  )
}

export default JobDetailStart